import React from 'react'
import NavigationTabs from '../nav/NavigationTabs';
import TextField from '@material-ui/core/TextField';
import { FileSelection } from '../../containers/Files'
import Button from '@material-ui/core/Button';
import ButtonContent from '../ButtonContent'
import { connect } from "react-redux";
import withAuth from '../../hocs/withAuth';
import MenuItem from '@material-ui/core/MenuItem';
import { updateUser } from "../../store/actions/auth";
import { AlertJsMessage, tzStrings } from './../../helpers.js'
import { MESSAGES } from '../../constants';

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      trainerImg: '',
      partnerImg: '',
      partnerDisplayName: ''
    }
  }

  componentDidMount() {
    const { user } = this.props;
    if (user) {
      this.setState({ ...user });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.user.firstName && this.props.user.firstName) {
      this.setState({ ...this.props.user });
    }
  }

  handleChange = field => event => {
    this.setState({
      ...this.state,
      [field]: event.target.value
    })
  }

  submitTrainerData() {
    const { type, selectedFile } = this.trainerFile.state;
    const { firstName, lastName } = this.state;
    if (!firstName) {
      AlertJsMessage('Please enter first name.');
      return;
    }
    if (!lastName) {
      AlertJsMessage('Please enter last name.');
      return;
    }
    if (type === 'library') {
      if (selectedFile) {
        const data = {
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          trainerImg: selectedFile.url,
          trainerFileId: selectedFile._id
        };
        this.submitForm(data);
      } else {
        AlertJsMessage(MESSAGES.IMAGE_COVER);
        return;
      }
    } else {
      this.setState({
        ...this.state,
        isValidating: true
      }, () => {
        if (!this.trainerFile.state.previewImageSrc) {
          AlertJsMessage(MESSAGES.IMAGE_COVER);
          return;
        }
        else {
          this.trainerFile.submitNewFile().then((file) => {
            const data = {
              firstName: this.state.firstName,
              lastName: this.state.lastName,
              trainerImg: file.url,
              trainerFileId: file._id
            };
            this.submitForm(data);
          })
        }
      })
    }
  }

  submitTimeZoneData() {
    const { timeZoneId } = this.state;
    if (!timeZoneId) {
      AlertJsMessage('Please select Timezone.');
      return;
    }
    const data = {
      timeZoneId: this.state.timeZoneId,
    };
    this.submitForm(data);
  }
  

  submitPartnerData() {
    const { type, selectedFile } = this.partnerFile.state;
    if (!this.state.partnerDisplayName) {
      AlertJsMessage('Please enter coach display name.');
      return;
    }
    if (type === 'library') {
      if (selectedFile) {
        const data = {
          partnerDisplayName: this.state.partnerDisplayName,
          partnerImg: selectedFile.url,
          partnerFileId: selectedFile._id
        };
        this.submitForm(data);
      } else {
        AlertJsMessage("Please select a video or image for the cover.");
        return;
      }
    } else {
      this.setState({
        ...this.state,
        isValidating: true
      }, () => {
        if (!this.partnerFile.state.previewImageSrc) {
          AlertJsMessage(MESSAGES.IMAGE_COVER);
          return;
        } else {
          this.partnerFile.submitNewFile().then((file) => {
            const data = {
              partnerDisplayName: this.state.partnerDisplayName,
              partnerImg: file.url,
              partnerFileId: file._id
            };
            this.submitForm(data);
          })
        }
      })
    }
  }

  submitForm(formData) {
    const { update } = this.props;
    update(formData).then(() => {
      window.location.reload();
    });
  }

  
  render() {

    const currentUser = this.props.currentUser;
    let trainerFileId, partnerFileId;
    if (currentUser) {
      trainerFileId = currentUser.user && currentUser.user.trainerFileId;
      partnerFileId = currentUser.user && currentUser.user.partnerFileId;
    }

    if (!this.props.currentUser && !this.props.currentUser.user) {
       return null;
    }
    
    return (
      <div>
        <NavigationTabs
          title="Settings"
          set="settings"
          currentUser={this.props.currentUser}
          activeRoute="/settings/edit-profile" />
        <h3>Trainer Profile</h3>
        <div>
          <div>
            Your trainer profile is viewable when you assign workouts to clients and customers.
          </div>
          <div>
              <FileSelection
                userData={this.props.user}
                fileType="image"
                category="profile"
                selectedFileId={trainerFileId ? trainerFileId : 0}
                ref={(ref) => { this.trainerFile = ref ? ref.getWrappedInstance() : null }}
              />
            <TextField
              style={{ maxWidth: 200, marginTop: 10, marginRight: 10 }}
              label="First Name"
              value={this.state.firstName}
              onChange={this.handleChange('firstName')}
              margin="dense"
              variant="outlined"
            />
            <TextField
              style={{ maxWidth: 200, marginTop: 10 }}
              label="Last Name"
              value={this.state.lastName}
              onChange={this.handleChange('lastName')}
              margin="dense"
              variant="outlined"
            />

          </div>
          <Button
            onClick={() => this.submitTrainerData()}
            variant="contained"
            color="primary">
            <ButtonContent
              text="Save Trainer Profile"
              icon="chevron-right" />
          </Button>

        </div>
        <hr />
        <h3>Timezone Preferences</h3>
        <div>
          <div>
              
          <TextField
                    style={{ maxWidth: 300, marginTop: 10 }}
                    label="Timezone"
                    value={this.state.timeZoneId}
                    name="timeZoneId"
                    margin="dense"
                    variant="outlined"
                    select
                    onChange={this.handleChange('timeZoneId')}
                >
                {tzStrings && tzStrings.map(option => (
                    <MenuItem key={option.id} value={option.id}>
                        {option.label}
                    </MenuItem>
                ))}
            </TextField>

          </div>
          <Button
            onClick={() => this.submitTimeZoneData()}
            variant="contained"
            color="primary">
            <ButtonContent
              text="Save"
              icon="chevron-right" />
          </Button>

        </div>

        <hr />
        <h3>Coach Channel Profile</h3>
        <div>
          <div>
          Your coach channel profile is viewable to anyone who accesses your coach channel.
          </div>
          <div>
            <FileSelection
              userData={this.props.user}
              isNoCropper = {true}
              fileType="image"
              category="profile"
              selectedFileId={partnerFileId ? partnerFileId : 0}
              ref={(ref) => { this.partnerFile = ref ? ref.getWrappedInstance() : null }}
            />
            <TextField
              style={{ maxWidth: 410, marginTop: 10, marginRight: 10 }}
              label="Coach Display Name"
              value={this.state.partnerDisplayName}
              onChange={this.handleChange('partnerDisplayName')}
              margin="dense"
              variant="outlined"
            />

          </div>
          <Button
            onClick={() => this.submitPartnerData()}
            variant="contained"
            color="primary">
            <ButtonContent
              text="Save Coach Profile"
              icon="chevron-right" />
          </Button>

        </div>
      </div>
    )
  }
}
function mapStateToProps(state, ownProps) {
  let { currentUser: { user } } = state;
  return {
    user: user
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    update: (data) => {
      return dispatch(updateUser(data));
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(withAuth(Profile));



// WEBPACK FOOTER //
// ./src/components/settings/Profile.js